var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSavedSearchesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 14",
    style: {
      enableBackground: "new 0 0 14 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3062",
    transform: "translate(-232.96 -294.505)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1769",
    x: 233,
    y: 294.5,
    width: 7.9,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1770",
    x: 233,
    y: 307.1,
    width: 7.9,
    height: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2849",
    className: "st0",
    d: "M238,297.7h-5v1.4h4.1C237.3,298.5,237.6,298.1,238,297.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2850",
    className: "st0",
    d: "M236.5,301.5c0-0.2,0-0.5,0-0.7H233v1.4h3.6C236.6,302,236.5,301.7,236.5,301.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2851",
    className: "st0",
    d: "M237.1,304H233v1.4h5C237.6,304.9,237.3,304.5,237.1,304z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2852",
    className: "st0",
    d: "M242.4,297c-2.5,0-4.5,2-4.5,4.5c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5S244.9,297,242.4,297 L242.4,297z M241.9,304.2l-2.7-2.6l0.9-1l1.8,1.7l2.8-2.9l0.9,0.9L241.9,304.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedSearchesIcon);
export default __webpack_public_path__ + "static/media/saved-searches-icon.23278d01.svg";
export { ForwardRef as ReactComponent };